<template>
    <div class="login-dashboard-platform" :class="classes" @click="actionRedirect">
        <img v-if="showComplianceLogo" src="../../assets/images/compliance-logo-black.svg" alt="Compliance Logo">
        <img v-if="showDfsLogo" src="../../assets/images/dfs-logo-black.svg" alt="DFS Logo" @click="actionRedirect">
        <img v-if="showAcademyLogo" src="../../assets/images/academy-logo-black.svg" alt="Academy Logo" @click="actionRedirect">
        <div v-if="loadingState" class="login-dashboard-platform-loader">
            <loader/>
        </div>
        <div v-if="!loadingState && !hasAccess" class="login-dashboard-platform-alert">
            <span @click="actionShowModal">Do you have account to pair?</span>
        </div>
        <account-pair-modal :platform-slug="slug"/>
    </div>
</template>

<script>
import AccountPairModal from "../modals/AccountPairModal";
import Loader from "../components/Loader";
import UrlMap from "../../js/slug-to-url-map";

export default {
        name: "LoginDashboardPlatform",
        components: {Loader, AccountPairModal},
        props: {
            slug: {
                type: String,
                required: true,
            },
            loadingState: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            oldAppUrl() {
                if (this.slug in UrlMap) {
                    return UrlMap[this.slug];
                }

                return '';
            },
            showComplianceLogo() {
                return this.slug === this.$enums.PlatformSlugEnum.COMPLIANCE;
            },
            showDfsLogo() {
                return this.slug === this.$enums.PlatformSlugEnum.DFS;
            },
            showAcademyLogo() {
                return this.slug === this.$enums.PlatformSlugEnum.ACADEMY;
            },
            platformAccesses() {
                return this.$parent.initData.platformAccesses ?? [];
            },
            hasAccess() {
                let platformAccess = this.platformAccesses.find(platformAccess => {
                    return platformAccess.slug === this.slug;
                });

                return platformAccess === undefined || platformAccess.hasAccess;
            },
            classes() {
                return {
                    'loading': this.loadingState,
                    'disabled': !this.hasAccess,
                }
            }
        },
        methods: {
            actionRedirect() {
                if (this.hasAccess) {
                    this.redirectToApp(this.oldAppUrl);
                }
            },
            actionShowModal() {
                let modalName = this.$enums.ModalNameEnum.ACCOUNT_PAIR + '-' + this.slug;
                this.$modals.show(modalName);
            },
            redirectToApp(url) {
                window.location.href = url;
            },
        }
    }
</script>